// extracted by mini-css-extract-plugin
export var cdsAssistiveText = "PageHeader-module--cds--assistive-text--d0a5a";
export var cdsHideFeedback = "PageHeader-module--cds--hide-feedback--91be0";
export var cdsShowFeedback = "PageHeader-module--cds--show-feedback--a1c06";
export var cdsSkeleton = "PageHeader-module--cds--skeleton--2acc7";
export var cdsVisuallyHidden = "PageHeader-module--cds--visually-hidden--ab058";
export var darkMode = "PageHeader-module--dark-mode--128f9";
export var pageHeader = "PageHeader-module--page-header--a2718";
export var text = "PageHeader-module--text--4cd9c";
export var withTabs = "PageHeader-module--with-tabs--8b47b";